import React from "react";
import styles from "./style.module.css";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import { useTheme } from "../../../../../../../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import { updateSkillImageData } from "../../../../../../../store/slices/profile/skillImageSlice";
import Head from "./components/head";
import Content from "./components/content";
import { updateInvalid } from "../../../../../../../store/slices/infoSlice";

const DialogBox = () => {
  const { theme } = useTheme();

  const dispatch = useDispatch();
  const { activeUserSkill } = useSelector((state) => state.user);
  const {
    data: { isSkillImageModalOpen },
  } = useSelector((state) => state.skillImage);

  const closeModal = () => {
    dispatch(
      updateSkillImageData({
        selectedSkillImage: null,
        isSkillImageModalOpen: false,
      })
    );
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    const fileSize = selectedFile?.size / 1024 / 1024;
    if (fileSize > 2) {
      dispatch(
        updateSkillImageData({
          isSkillImageModalOpen: false,
          selectedSkillImage: null,
        })
      );
      dispatch(
        updateInvalid({
          isInvalidOpen: true,
          message:
            "Skill Image size should be less than or equal to 2MB. Please upload a smaller image",
        })
      );
      return;
    }
    if (selectedFile) {
      dispatch(
        updateSkillImageData({
          selectedSkillImage: URL.createObjectURL(selectedFile),
        })
      );
    }

    dispatch(updateSkillImageData({ isSkillImageModalOpen: false }));
  };

  const handleEdit = () => {
    dispatch(
      updateSkillImageData({
        selectedSkillImage: activeUserSkill?.originalCoverImage,
        isSkillImageModalOpen: false,
      })
    );
  };

  const handleDelete = () => {
    dispatch(
      updateSkillImageData({
        isSkillImageDeleteOpen: true,
        isSkillImageModalOpen: false,
        selectedSkillImage: null,
      })
    );
  };

  return (
    <Box
      className={styles.coverImage}
      sx={{
        display: isSkillImageModalOpen ? "flex" : "none",
        backgroundImage: `url(${activeUserSkill?.skillCoverImage})`,
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Modal
        open={isSkillImageModalOpen}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              bgcolor: theme.palette.lightgrey.lightgrey500,
              width: {
                xs: "100%",
                md: "400px",
              },
            }}
            className={styles.dialogBox}
          >
            <Head closeModal={closeModal} />
            <Content
              handleFileChange={handleFileChange}
              handleEdit={handleEdit}
              handleDelete={handleDelete}
            />
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default DialogBox;
